var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66669 18.8334C1.66669 15.1515 4.65145 12.1667 8.33335 12.1667C12.0153 12.1667 15 15.1515 15 18.8334H13.3334C13.3334 16.072 11.0948 13.8334 8.33335 13.8334C5.57193 13.8334 3.33335 16.072 3.33335 18.8334H1.66669ZM8.33335 11.3334C5.57085 11.3334 3.33335 9.09587 3.33335 6.33337C3.33335 3.57087 5.57085 1.33337 8.33335 1.33337C11.0959 1.33337 13.3334 3.57087 13.3334 6.33337C13.3334 9.09587 11.0959 11.3334 8.33335 11.3334ZM8.33335 9.66671C10.175 9.66671 11.6667 8.17504 11.6667 6.33337C11.6667 4.49171 10.175 3.00004 8.33335 3.00004C6.49169 3.00004 5.00002 4.49171 5.00002 6.33337C5.00002 8.17504 6.49169 9.66671 8.33335 9.66671ZM15.2364 12.7524C17.5537 13.7968 19.1667 16.1267 19.1667 18.8334H17.5C17.5 16.8034 16.2903 15.056 14.5524 14.2726L15.2364 12.7524ZM14.6635 3.34438C16.3287 4.0309 17.5 5.66972 17.5 7.58337C17.5 9.97521 15.6702 11.9377 13.3334 12.148V10.4705C14.7473 10.2685 15.8334 9.05337 15.8334 7.58337C15.8334 6.43283 15.168 5.4384 14.2009 4.96367L14.6635 3.34438Z",
    fill: "#6F7376"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.7f52d53611b371a814007192bca76090.svg";
export { ForwardRef as ReactComponent };